import { PointColorConfiguration } from '../../commonUI/maps/types';
import { BlockPointData } from './hooks/useGetBlockPoints';

export const BLOCK_POINTS_MAP_COLOR_CONFIG: PointColorConfiguration<BlockPointData> =
  {
    max: 300,
    min: 0,
    color: '#285A3A',
    property: 'stageTotalCount',
  };
